import cmp from './FileUploader'

export default cmp
